import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'add-certificate-modal',
  templateUrl: './add-certificate-modal.component.html'
})
export class AddCertificateModalComponent implements OnInit {
  @Input() competencyOptions: any;

  public form: FormGroup;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      competency: new FormControl(),
    });
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public onSubmit() {
    this.activeModal.close(({
      value: this.form.value
    }));
  }
}
